export default __webpack_public_path__ + "static/media/0062.772e72e9.png";